import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import styles from './style.css';
import { SignInEmailErrorCodeEnum } from "../../../domain/enums/SignInEmailErrorEnum";
import { 
  abeEmailSelector, 
  abeFormErrorsSelector,
  abePasswordSelector,
  emailSignInMethodSelector
} from "../../../store/auth-by-email/selectors";
import {
  loginByEmail, 
  checkEmailUsage, 
  setEmail, 
  setFormErrors, 
  setPassword,
  setEmailSignInMethod
} from "../../../store/auth-by-email/actions";
import UQFormErrors from "../../../../uq-forms/components/form-errors";
import UQFormsTextField from "../../../../uq-forms/components/text-field";
import UQFormsPasswordField from "../../../../uq-forms/components/password-field";
import UQButton from "../../../../uq-ui/components/button";
import { currentUserInfoSelector } from "../../../store/auth-user/selectors";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import Div100vh from "../../../../uq-ui/components/div-100";
import { createErrorExtractor } from "../../../../uq-forms/helpers";

const GreetingImage = require('./greeting.svg');

const errorExtractor = createErrorExtractor({
  email: {
    [SignInEmailErrorCodeEnum.InvalidEmail]: 'errors.invalidEmail',
    [SignInEmailErrorCodeEnum.EmailAlreadyInUse]: 'errors.emailAlreadyInUse',
  },
  password: {
    [SignInEmailErrorCodeEnum.WrongPassword]: 'errors.wrongPassword',
  },
  form: {
    [SignInEmailErrorCodeEnum.EmailAlreadyInUse]: 'errors.emailAlreadyInUse',
    [SignInEmailErrorCodeEnum.UserNotFound]: 'errors.accountNotFound',
    [SignInEmailErrorCodeEnum.UserDisabled]: 'errors.accountDisabled',
  }
});

class AuthScreensLoginByEmail extends PureComponent {

  onBack = () => {
    this.props.history.replace('/login');
    this.props.setEmailSignInMethod(false);
  };

  componentDidMount() {
    this.props.resetFormErrors();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showEmailSignIn && this.props.showEmailSignIn) {
      this.props.resetFormErrors();
    }
  }

  renderEmailVerification() {
    return (
      <div className={styles.innerTop}>
        <div className={`${styles.authTogglerLinkActive} font-title`}>{this.props.t('yourEmail')}</div>
        <div className={styles.formContainer}>
          <div className={styles.form}>
            <UQFormsTextField
              label={this.props.t('email')}
              type="email"
              labelClassName="font-text"
              autoCapitalize="none"
              value={this.props.email}
              error={errorExtractor.get('email', this.props.formErrors, this.props.t)}
              onChange={(event) => this.props.onChangeEmail(event.target.value)}
            />
            <UQFormErrors
              textStyle={{ textAlign: 'center', fontSize: '13px' }}
              textClass={styles.errorForm}
              error={errorExtractor.get('form', this.props.formErrors, this.props.t)} />
          </div>
        </div>
        <UQButton label={this.props.t('continueBtn')}
                  onPress={this.props.checkEmailUsage}
                  containerClass={styles.continueBtnWrap}
                  innerClass={styles.submitBtn}/>
      </div>
    );
  }

  renderLoginByEmail() {
    return (
      <div className={styles.innerTop}>
        <div className={`${styles.authTogglerLinkActive} font-title`}>{this.props.t('login')}</div>
        <div className={styles.formContainer}>
          <div className={styles.form}>
            { this.props.formErrors.form && (
              <UQFormErrors
                textStyle={{ textAlign: 'center' }}
                error={errorExtractor.get('form', this.props.formErrors, this.props.t)} />
            ) }
            <UQFormsTextField
              label={this.props.t('email')}
              type="email"
              labelClassName="font-text"
              autoCapitalize="none"
              value={this.props.email}
              error={errorExtractor.get('email', this.props.formErrors, this.props.t)}
              onChange={(event) => this.props.onChangeEmail(event.target.value)}
            />
            <UQFormsPasswordField
              label={this.props.t('password')}
              labelClassName="font-text"
              autoCapitalize="none"
              value={this.props.password}
              error={errorExtractor.get('password', this.props.formErrors, this.props.t)}
              onChange={(event) => this.props.onChangePassword(event.target.value)}
            />
            <div className={styles.forgotPasswordContainer}>
              <Link className={`${styles.forgotPassword} font-text`}
                    to="/login/email/forgot">
                {this.props.t("forgotPasswordLink")}
              </Link>
            </div>
          </div>
        </div>
        <UQButton label={this.props.t('loginBtn')}
                  onPress={this.props.loginByEmail}
                  containerClass={styles.submitBtnWrap}
                  innerClass={styles.submitBtn}/>
      </div>
    );
  }

  render() {
    return (
      <Div100vh className={styles.container}>
        <LayoutComponentsHeader showBackBtn={true} 
                                onBack={this.onBack} 
                                showLogo={true} />
        { !this.props.showEmailSignIn && this.renderEmailVerification() }
        { this.props.showEmailSignIn && this.renderLoginByEmail() }
        <div className={styles.innerBottom}>
          <img src={GreetingImage} className={styles.greeting} />
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: abeEmailSelector(state),
    password: abePasswordSelector(state),
    formErrors: abeFormErrorsSelector(state),
    currentUserInfo: currentUserInfoSelector(state),
    showEmailSignIn: emailSignInMethodSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangePassword: (value) => dispatch(setPassword(value)),
    onChangeEmail: (value) => dispatch(setEmail(value)),
    resetFormErrors: () => dispatch(setFormErrors({})),
    loginByEmail: () => dispatch(loginByEmail()),
    checkEmailUsage: () => dispatch(checkEmailUsage()),
    setEmailSignInMethod: (allow) => dispatch(setEmailSignInMethod(allow))
  }
};

export default compose(
  withTranslation('scr-login'),
  connect(mapStateToProps, mapDispatchToProps)
)(AuthScreensLoginByEmail);